import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { FiLogOut, FiMoon, FiShield, FiSun, FiX } from 'react-icons/fi';
import { useApp } from '../../context/AppContext';
import { Button } from '../../styles/GlobalStyles';
import { useNdTheme } from '../../utils/ndTheme';
import { formatUserOrgLines } from '../../utils/orgStructure';
import '../../styles/newDesign.css';
import SidebarNav from './SidebarNav';
import ChatList from './ChatList';
import AllUsers from '../AllUsers';
import GeneralCalendarModal from '../GeneralCalendarModal';
import TwoFactorSettingsModal from '../Modals/TwoFactorSettingsModal';
// import christmasTreeImg from '../../assets/icons/cristmas.png';
import frostyImg from '../../assets/icons/Frosty.png';

const SNOWFLAKE_COUNT = 14;

// Вывеска статуса сервера в стиле магазина
const ServerStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
  font-weight: 800;
  padding: 12px 20px;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 12px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-shadow: 0 0 10px currentColor, 0 0 20px currentColor, 0 0 30px currentColor;
  animation: ${props => props.connected ? 'pulse-green 2s ease-in-out infinite' : 'pulse-red 2s ease-in-out infinite'};
  box-shadow: ${props => props.connected 
    ? '0 0 20px rgba(67, 233, 123, 0.5), inset 0 0 20px rgba(67, 233, 123, 0.1)' 
    : '0 0 20px rgba(231, 76, 60, 0.5), inset 0 0 20px rgba(231, 76, 60, 0.1)'};
  color: ${props => props.connected ? '#43e97b' : '#e74c3c'};
  background: ${props => props.connected 
    ? 'linear-gradient(135deg, rgba(67, 233, 123, 0.15) 0%, rgba(67, 233, 123, 0.05) 100%)' 
    : 'linear-gradient(135deg, rgba(231, 76, 60, 0.15) 0%, rgba(231, 76, 60, 0.05) 100%)'};
  border: 2px solid ${props => props.connected ? 'rgba(67, 233, 123, 0.4)' : 'rgba(231, 76, 60, 0.4)'};
  
  @keyframes pulse-green {
    0%, 100% {
      text-shadow: 0 0 10px #43e97b, 0 0 20px #43e97b, 0 0 30px #43e97b;
      box-shadow: 0 0 20px rgba(67, 233, 123, 0.5), inset 0 0 20px rgba(67, 233, 123, 0.1);
    }
    50% {
      text-shadow: 0 0 15px #43e97b, 0 0 30px #43e97b, 0 0 45px #43e97b;
      box-shadow: 0 0 30px rgba(67, 233, 123, 0.7), inset 0 0 30px rgba(67, 233, 123, 0.2);
    }
  }
  
  @keyframes pulse-red {
    0%, 100% {
      text-shadow: 0 0 10px #e74c3c, 0 0 20px #e74c3c, 0 0 30px #e74c3c;
      box-shadow: 0 0 20px rgba(231, 76, 60, 0.5), inset 0 0 20px rgba(231, 76, 60, 0.1);
    }
    50% {
      text-shadow: 0 0 15px #e74c3c, 0 0 30px #e74c3c, 0 0 45px #e74c3c;
      box-shadow: 0 0 30px rgba(231, 76, 60, 0.7), inset 0 0 30px rgba(231, 76, 60, 0.2);
    }
  }
`;
// import GeneralCalendarModal from '../GeneralCalendarModal';
// import OnlineUsers from './OnlineUsers';
// import Emoji from '../Common/Emoji';

// Модальное окно для просмотра аватарки
const AvatarModalBg = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const AvatarModalImg = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 18px;
  box-shadow: 0 8px 40px 0 rgba(31,38,135,0.25);
`;
const AvatarModalCloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 10000;
  
  &:hover {
    background: rgba(231, 76, 60, 0.8);
    transform: scale(1.1);
  }
`;
const SidebarContainer = styled.div`
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 12px;
  border-radius: 0;
  border-right: 1px solid var(--nd-stroke);
  background: var(--nd-panel);
  backdrop-filter: blur(20px);
  color: var(--nd-txt);
  font-family: 'Inter', system-ui, sans-serif;
  font-size: 13px;
  margin: 18px 0 18px 18px;
  overflow-x: hidden;
  overflow-y: auto;
  transition: background 0.4s, color 0.4s;
  animation: sidebarFadeIn 0.4s cubic-bezier(.4,0,.2,1);
  @keyframes sidebarFadeIn {
    from { opacity: 0; transform: translateX(-40px) scale(0.98); }
    to { opacity: 1; transform: none; }
  }

  @media (min-width: 769px) {
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    right: auto !important;
    height: 100vh !important;
    width: 320px !important;
    margin: 0 !important;
    border-radius: 0 !important;
    z-index: 1000000 !important;
    transform: none !important;
  }

  @media (max-width: 768px) {
    display: none; /* Скрываем десктопный сайдбар на мобильных устройствах */
  }
`;

const ChatControls = styled.div`
  padding: 1rem;
  border-bottom: 1px solid #232931;
  background: rgba(44,62,80,0.85);
`;

const CreateChatButton = styled(Button)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%);
  color: #fff;
  font-weight: 700;
  font-size: 1.08rem;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(44,62,80,0.10);
  border: none;
  margin-top: 6px;
  transition: all 0.2s;
  &:hover {
    background: linear-gradient(135deg, #6dd5ed 0%, #2193b0 100%);
    color: #fff;
    transform: scale(1.04);
    box-shadow: 0 4px 16px rgba(44,62,80,0.13);
  }
`;

const RightsButton = styled(Button)`
  width: calc(100% - 32px);
  margin: 12px 16px 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: linear-gradient(135deg, #6dd5ed 0%, #2193b0 100%);
  color: #fff;
  font-weight: 800;
  font-size: 1.08rem;
  padding: 12px 14px;
  border: none;
  border-radius: 14px;
  box-shadow: 0 6px 18px rgba(33,147,176,0.28), 0 0 0 2px rgba(67,233,123,0.12);
  transition: transform .12s ease, box-shadow .2s ease, opacity .2s ease, background .2s ease;
  &:hover {
    background: linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%);
    transform: translateY(-1px);
    box-shadow: 0 10px 28px rgba(33,147,176,0.36), 0 0 0 2px rgba(67,233,123,0.18);
  }
  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 12px rgba(33,147,176,0.24), 0 0 0 2px rgba(67,233,123,0.16);
  }
`;
// Обертка и панель с размерами как у модалки создания задач
const RightsWrapper = styled.div`
  position: fixed;
  top: 0;
  left: calc(380px + max((100vw - 380px - 1200px)/2, 0px));
  width: 1170px;
  min-width: 600px;
  max-width: 1170px;
  height: 92vh;
  margin: 32px 0;
  z-index: 200000;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  pointer-events: auto;
`;

const RightsPanel = styled.div`
  background: linear-gradient(135deg, #232931 0%, #181c22 100%);
  border-radius: 28px;
  width: 100%;
  min-width: 600px;
  max-width: 1200px;
  height: 100%;
  box-sizing: border-box;
  box-shadow: 0 4px 32px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  position: relative;
  color: #fff;
  padding: 40px 48px;
  overflow-y: auto;
  overflow-x: hidden;
`;

const RightsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 14px 0;
  color: #fff;
`;

const RightsTitle = styled.div`
  font-weight: 800;
  font-size: 1.08rem;
`;

const RightsClose = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 1.6rem;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s, color 0.3s;
  &:hover { background: rgba(34, 197, 94, 0.18); color: #43e97b; }
`;

const RightsBody = styled.div`
  flex: 1;
  overflow: auto;
  padding-right: 8px;
`;

const DEFAULT_APP_TITLE_SETTINGS = {
  text: 'Issa Plus',
  fontSize: '2em',
  fontFamily: 'Arial, sans-serif',
  customFontUrl: '',
  customFontName: '',
  color: '#43e97b',
  useGradient: false,
  gradientStart: '#43e97b',
  gradientEnd: '#2193b0',
  glowEnabled: true,
  glowColor: '#43e97b',
  glowIntensity: 12,
  glowSpread: 32,
  effectType: 'neon',
  snowmanEnabled: false,
  snowmanImage: null,
  snowmanPositionX: 0,
  snowmanPositionY: 0,
  snowmanScale: 100,
  snowmanPositionType: 'relative',
  avatarImage: null,
  avatarPositionX: 0,
  avatarPositionY: 0,
  avatarWidth: 88,
  avatarHeight: 88
};

function getAppTitleSettings() {
  try {
    const saved = localStorage.getItem('appTitleSettings');
    if (saved) {
      return { ...DEFAULT_APP_TITLE_SETTINGS, ...JSON.parse(saved) };
    }
  } catch (e) {
    console.error('Error loading app title settings:', e);
  }
  return DEFAULT_APP_TITLE_SETTINGS;
}

// Глобальные стили для снега
const SnowGlobalStyle = createGlobalStyle`
  .snow-container {
    pointer-events: none;
    position: absolute;
    left: 0; right: 0; top: 0; height: 100%; width: 100%;
    z-index: 10000;
    overflow: visible;
  }
  .snowflake {
    position: absolute;
    top: -32px;
    color: #fff;
    opacity: 0.85;
    user-select: none;
    pointer-events: none;
    animation-name: snow-fall-sidebar;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    will-change: transform;
    text-shadow: 0 0 8px #fff, 0 0 12px #6dd5ed;
  }
  @keyframes snow-fall-sidebar {
    0% { transform: translateY(0) translateX(0); opacity: 0.85; }
    80% { opacity: 0.85; }
    100% { transform: translateY(340px) translateX(var(--snow-x, 0px)); opacity: 0.2; }
  }
`;

export default function Sidebar() {
  const { state, dispatch } = useApp();
  const { isLight: ndIsLight, toggle: toggleNdTheme } = useNdTheme();
  const fileInputRef = useRef();
  const [avatarHover, setAvatarHover] = useState(false);
  const [showAvatarModal, setShowAvatarModal] = useState(false);
  const [showTwoFactorModal, setShowTwoFactorModal] = useState(false);
  const [showGeneralCalendar, setShowGeneralCalendar] = useState(false);
  const [generalEvents, setGeneralEvents] = useState([]);
  const [socketConnected, setSocketConnected] = useState(() => window.socket?.connected ?? false);
  const [showAllUsers, setShowAllUsers] = useState(false);
  const [appTitleSettings, setAppTitleSettings] = useState(getAppTitleSettings());

  // Функция нормализации URL аватарки
  // Используем относительные пути, чтобы прокси (настроен в package.json) перенаправлял на сервер
  const normalizeAvatarUrl = (url) => {
    if (!url || typeof url !== 'string') return null;
    let trimmed = url.trim();
    // Normalize Windows backslashes to forward slashes
    trimmed = trimmed.replace(/\\/g, '/');
    
    // Если уже полный URL, возвращаем как есть
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
    
    // Извлекаем путь к файлу из абсолютного пути Windows
    const idx = trimmed.toLowerCase().indexOf('/uploads/avatars/');
    if (idx !== -1) {
      // Возвращаем относительный путь - прокси автоматически перенаправит на сервер
      return trimmed.slice(idx);
    }
    
    if (!trimmed) return null;
    
    // Если путь уже начинается с /uploads или /images, возвращаем как есть
    if (trimmed.startsWith('/uploads') || trimmed.startsWith('/images')) {
      return trimmed;
    }
    
    // Если путь начинается с uploads/ (без слэша), добавляем слэш
    if (trimmed.startsWith('uploads/')) {
      return `/${trimmed}`;
    }
    
    // Иначе предполагаем, что это имя файла, добавляем путь
    return `/uploads/avatars/${trimmed.replace(/^\/+/, '')}`;
  };

  // Нормализованный URL аватарки пользователя
  const normalizedAvatarUrl = state.user?.avatarUrl ? normalizeAvatarUrl(state.user.avatarUrl) : null;
  const avatarSrc = appTitleSettings.avatarImage || normalizedAvatarUrl || null;
  const userInitials = React.useMemo(() => {
    const name = String(state.user?.username || '').trim();
    if (!name) return '?';
    const parts = name.split(/\s+/).filter(Boolean);
    const letters = parts.length > 1 ? parts[0][0] + parts[1][0] : name.slice(0, 2);
    return letters.toUpperCase();
  }, [state.user?.username]);

  const snowflakes = React.useMemo(
    () => Array.from({ length: SNOWFLAKE_COUNT }),
    []
  );
  const isWinterSeason = React.useMemo(() => {
    const today = new Date();
    const month = today.getMonth(); // 0 - январь, 11 - декабрь
    const day = today.getDate();
    if (month === 11) return true; // декабрь
    if (month === 0) return true; // январь
    if (month === 1 && day <= 28) return true; // февраль до 28 включительно
    return false;
  }, []);

  // Настройка снега из localStorage
  const [snowEnabled, setSnowEnabled] = React.useState(() => {
    try {
      const saved = localStorage.getItem('appTitleSettings');
      if (saved) {
        const settings = JSON.parse(saved);
        return settings.snowEnabled !== undefined ? settings.snowEnabled : null;
      }
    } catch (e) {
      console.error('Error loading snow settings:', e);
    }
    return null; // null = автоматически
  });

  // Определяем, показывать ли снег
  // Снег включён, если явно true, либо null (авто) и сейчас зима
  let shouldShowSnow = false;
  if (appTitleSettings.snowEnabled === true) {
    shouldShowSnow = true;
  } else if (appTitleSettings.snowEnabled === null || appTitleSettings.snowEnabled === undefined) {
    shouldShowSnow = isWinterSeason;
  } // если false — снег выключен

  // Слушаем изменения настроек снега
  useEffect(() => {
    const handler = () => {
      try {
        const saved = localStorage.getItem('appTitleSettings');
        if (saved) {
          const settings = JSON.parse(saved);
          setSnowEnabled(settings.snowEnabled !== undefined ? settings.snowEnabled : null);
        } else {
          setSnowEnabled(null);
        }
      } catch (e) {
        console.error('Error loading snow settings:', e);
      }
    };
    window.addEventListener('appTitleSettingsUpdated', handler);
    return () => window.removeEventListener('appTitleSettingsUpdated', handler);
  }, []);
  
  // Загрузка настроек названия приложения и загрузка кастомных шрифтов
  useEffect(() => {
    const settings = getAppTitleSettings();
    setAppTitleSettings(settings);
    
    // Загрузка кастомного шрифта, если указан URL
    if (settings.customFontUrl) {
      const existingLink = document.querySelector(`link[data-custom-font="${settings.customFontUrl}"]`);
      if (!existingLink) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = settings.customFontUrl;
        link.setAttribute('data-custom-font', settings.customFontUrl);
        document.head.appendChild(link);
      }
    }
    
    // Загрузка кастомного шрифта из локального файла (dataUrl)
    if (settings.customFontDataUrl && settings.customFontName) {
      const prevStyle = document.getElementById('custom-font-style');
      if (prevStyle) prevStyle.remove();
      const style = document.createElement('style');
      style.id = 'custom-font-style';
      style.innerHTML = `@font-face { font-family: '${settings.customFontName}'; src: url('${settings.customFontDataUrl}'); font-display: swap; }`;
      document.head.appendChild(style);
    }
    
    const handler = () => {
      console.log('🔄 Sidebar: appTitleSettingsUpdated event received');
      const newSettings = getAppTitleSettings();
      console.log('🔄 Sidebar: New settings loaded:', newSettings);
      // Создаем новый объект для принудительного обновления React
      setAppTitleSettings({ ...newSettings });
      
      // Загрузка нового кастомного шрифта, если изменился URL
      if (newSettings.customFontUrl) {
        const existingLink = document.querySelector(`link[data-custom-font="${newSettings.customFontUrl}"]`);
        if (!existingLink) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = newSettings.customFontUrl;
          link.setAttribute('data-custom-font', newSettings.customFontUrl);
          document.head.appendChild(link);
        }
      }
      
      // Загрузка кастомного шрифта из локального файла (dataUrl)
      if (newSettings.customFontDataUrl && newSettings.customFontName) {
        const prevStyle = document.getElementById('custom-font-style');
        if (prevStyle) prevStyle.remove();
        const style = document.createElement('style');
        style.id = 'custom-font-style';
        style.innerHTML = `@font-face { font-family: '${newSettings.customFontName}'; src: url('${newSettings.customFontDataUrl}'); font-display: swap; }`;
        document.head.appendChild(style);
      } else if (!newSettings.customFontDataUrl && !newSettings.customFontUrl) {
        // Если убрали кастомный шрифт — чистим style
        const prevStyle = document.getElementById('custom-font-style');
        if (prevStyle) prevStyle.remove();
      }
    };
    window.addEventListener('appTitleSettingsUpdated', handler);
    return () => window.removeEventListener('appTitleSettingsUpdated', handler);
  }, []);

  // Открытие панели прав из других частей приложения
  useEffect(() => {
    const handler = () => setShowAllUsers(v => !v);
    window.addEventListener('toggle-users-rights', handler);
    return () => window.removeEventListener('toggle-users-rights', handler);
  }, []);

  // Обновление аватарки пользователя из других компонентов (например, CompanyEmployeesListModal)
  useEffect(() => {
    const handler = (e) => {
      const newAvatarUrl = e.detail;
      if (newAvatarUrl) {
        dispatch({ type: 'UPDATE_USER_AVATAR', payload: newAvatarUrl });
        console.log('✅ [Sidebar] Аватарка обновлена через событие:', newAvatarUrl);
      }
    };
    window.addEventListener('updateUserAvatar', handler);
    return () => window.removeEventListener('updateUserAvatar', handler);
  }, [dispatch]);

  const [showChatsModal, setShowChatsModal] = useState(false);

  // Следим за статусом соединения
  React.useEffect(() => {
    const check = () => setSocketConnected(window.socket?.connected ?? false);
    check();
    const interval = setInterval(check, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    // TODO: добавить валидацию типа/размера
    const formData = new FormData();
    formData.append('avatar', file);
    try {
      const res = await fetch('/api/upload-avatar', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: formData
      });
      const data = await res.json();
      if (data?.avatarUrl) {
        dispatch({ type: 'UPDATE_USER_AVATAR', payload: data.avatarUrl });
      }
    } catch (err) {
      alert('Ошибка загрузки аватара');
    }
  };

  const handleRemoveAvatar = async () => {
    if (!window.confirm('Удалить аватар?')) return;
    try {
      const res = await fetch('/api/remove-avatar', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const data = await res.json();
      if (data?.success) {
        dispatch({ type: 'UPDATE_USER_AVATAR', payload: null });
      }
    } catch (err) {
      alert('Ошибка удаления аватара');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    dispatch({ type: 'LOGOUT' });
  };

  const handleCreateChat = () => {
    dispatch({ 
      type: 'TOGGLE_MODAL', 
      payload: { modal: 'createChat', show: true } 
    });
  };

  React.useEffect(() => {
    const handler = () => setShowGeneralCalendar(true);
    window.addEventListener('show-all-leaves', handler);
    return () => window.removeEventListener('show-all-leaves', handler);
  }, []);

  // Реакция на глобальное закрытие всех модалок
  React.useEffect(() => {
    const onCloseAll = () => {
      setShowAllUsers(false);
      setShowAvatarModal(false);
    };
    window.addEventListener('close-all-modals', onCloseAll);
    return () => window.removeEventListener('close-all-modals', onCloseAll);
  }, []);

  // Загрузка событий для общего календаря при открытии модалки
  React.useEffect(() => {
    if (!showGeneralCalendar) return;
    
    const token = localStorage.getItem('token');
    if (!token) return;
    
    const user = state.user;
    const isAdminOrHR = user?.role === 'admin' || 
                       user?.department === 'HR-менеджер (менеджер по персоналу)';
    
    fetch('/api/all-leaves', { 
      headers: { Authorization: `Bearer ${token}` } 
    })
      .then(r => r.json())
      .then(data => {
        const leaves = Array.isArray(data) ? data : [];
        // Преобразуем данные в формат для календаря
        const events = leaves
          .filter(leave => {
            // Для админа/HR показываем все отгулы (включая pending), для остальных - только одобренные
            return isAdminOrHR || leave.status === 'approved';
          })
          .map(leave => {
            // Определяем тип события
            let type = 'leave';
            if (leave.type === 'vacation') type = 'vacation';
            else if (leave.type === 'sick') type = 'sick';
            else if (leave.type === 'leave') {
              // Проверяем причину для определения больничного
              const reason = String(leave.reason || '').toLowerCase();
              if (/болею|больнич/i.test(reason)) type = 'sick';
            }
            
            return {
              startDate: leave.startDate,
              endDate: leave.endDate,
              type: type
            };
          });
        setGeneralEvents(events);
      })
      .catch(err => {
        console.error('Ошибка загрузки событий для календаря:', err);
        setGeneralEvents([]);
      });
  }, [showGeneralCalendar, state.user]);

  return (
    <>
      <SnowGlobalStyle />
      <SidebarContainer className="nd-sidebar">
          {/* Снеговик (абсолютное позиционирование по блоку) */}
          {appTitleSettings.snowmanEnabled && appTitleSettings.snowmanPositionType === 'absolute' && (
            <img
              src={appTitleSettings.snowmanImage || frostyImg}
              alt="Снеговик"
              style={{
                position: 'absolute',
                left: `calc(50% + ${appTitleSettings.snowmanPositionX || 0}px)`,
                top: `${appTitleSettings.snowmanPositionY || 0}px`,
                transform: 'translateX(-50%)',
                width: `${(appTitleSettings.snowmanScale || 100) * 0.6}px`,
                height: 'auto',
                zIndex: 10,
                pointerEvents: 'none',
                userSelect: 'none'
              }}
            />
          )}
          {shouldShowSnow && (
            <div className="snow-container">
              {snowflakes.map((_, index) => (
                <span
                  key={index}
                  className={`snowflake snowflake-${index}`}
                  style={{
                    left: `${(index / SNOWFLAKE_COUNT) * 100}%`,
                    animationDelay: `${index * 0.45}s`,
                    animationDuration: `${4 + (index % 3)}s`,
                    fontSize: `${12 + (index % 4) * 2}px`,
                    ['--snow-x']: `${-30 + (index % 7) * 12}px`,
                    ['--snow-y']: `${140 + (index % 6) * 18}px`
                  }}
                >
                  ❄
                </span>
              ))}
            </div>
          )}
          <div className="nd-logoRow">
            <div className="nd-logoIco">💬</div>
            <div className="nd-logoT">
              <b>{appTitleSettings.subtitleText || 'Мульти - мессенджер'}</b>
              <span className="nd-brand">{appTitleSettings.text || 'Issa Plus'}</span>
            </div>
          </div>

          <div className="nd-userCard">
            <div
              className="nd-uAv"
              onMouseEnter={() => setAvatarHover(true)}
              onMouseLeave={() => setAvatarHover(false)}
              onClick={() => {
                if (avatarSrc) setShowAvatarModal(true);
                else fileInputRef.current?.click();
              }}
              title={avatarSrc ? 'Просмотреть/изменить аватар' : 'Загрузить аватар'}
            >
              {avatarSrc ? <img src={avatarSrc} alt="avatar" /> : userInitials}
              {avatarHover && avatarSrc && (
                <span
                  className="nd-uAvEdit nd-del"
                  title="Удалить аватар"
                  onClick={e => { e.stopPropagation(); handleRemoveAvatar(); }}
                >✕</span>
              )}
              {avatarHover && (
                <span
                  className="nd-uAvEdit nd-set"
                  title="Загрузить новый аватар"
                  onClick={e => { e.stopPropagation(); fileInputRef.current?.click(); }}
                >✎</span>
              )}
            </div>
            <div className="nd-uT">
              <b>{state.user?.username}</b>
              {formatUserOrgLines(state.user).map((line) => (
                <span key={line} className="nd-uOrg" title={line}>{line}</span>
              ))}
            </div>
            <span
              className={socketConnected ? 'nd-uSt' : 'nd-uSt nd-off'}
              title={socketConnected ? 'Соединение с сервером активно' : 'Нет соединения с сервером'}
            />
            <div className="nd-uActs">
              <button
                type="button"
                onClick={toggleNdTheme}
                title={ndIsLight ? 'Включить тёмную тему' : 'Включить светлую тему'}
              >
                {ndIsLight ? <FiMoon size={13} /> : <FiSun size={13} />}
              </button>
              <button type="button" onClick={() => setShowTwoFactorModal(true)} title="Двухфакторный вход (2FA)">
                <FiShield size={13} />
              </button>
              <button type="button" className="nd-danger" onClick={handleLogout} title="Выйти из аккаунта">
                <FiLogOut size={13} />
              </button>
            </div>
          </div>

          <input ref={fileInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleAvatarChange} />

          {showAvatarModal && avatarSrc && (
            <AvatarModalBg onClick={() => setShowAvatarModal(false)}>
              <AvatarModalCloseButton onClick={() => setShowAvatarModal(false)} title="Закрыть">
                <FiX />
              </AvatarModalCloseButton>
              <AvatarModalImg src={avatarSrc} alt="avatar-large" onClick={e => e.stopPropagation()} />
            </AvatarModalBg>
          )}

          <SidebarNav showChatsModal={showChatsModal} setShowChatsModal={setShowChatsModal} hideTitle={true} />

        {showAllUsers && createPortal((
          <RightsWrapper onClick={()=>setShowAllUsers(false)}>
            <RightsPanel onClick={e=>e.stopPropagation()}>
              <RightsClose onClick={()=>setShowAllUsers(false)} title="Закрыть" style={{position:'absolute',top:16,right:16}}>×</RightsClose>
              <RightsHeader>
                <RightsTitle>Права пользователей</RightsTitle>
              </RightsHeader>
              <RightsBody>
                <AllUsers token={localStorage.getItem('token')} isAdmin={state.user?.role === 'admin'} />
              </RightsBody>
            </RightsPanel>
          </RightsWrapper>
        ), document.body)}
        
        {showGeneralCalendar && createPortal(
          <GeneralCalendarModal 
            open={showGeneralCalendar} 
            onClose={() => setShowGeneralCalendar(false)} 
            events={generalEvents} 
          />,
          document.body
        )}
        <TwoFactorSettingsModal open={showTwoFactorModal} onClose={() => setShowTwoFactorModal(false)} />
      </SidebarContainer>
    </>
  );
}